// Shared cache tag linking tour queries (meta.tags) to the mutations that invalidate them (meta.invalidates).
export const ZCALENDAR_TOURS_QUERY_TAG = 'zcalendar:tours';

// Tour config is read separately from tours; tagged so config-mutating flows can invalidate it.
export const ZCALENDAR_TOUR_CONFIG_QUERY_TAG = 'zcalendar:tourConfig';
